import { render } from "./index.vue?vue&type=template&id=b8ea61ce&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=b8ea61ce&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ea61ce"]])

export default __exports__